<template>
    <v-row>
        <v-col cols="12" md="12" style="padding-left: 35px;">
            <v-row>
                <v-col cols="12" md="12">
                    <h2>
                        {{ trans('user_detail.in_progress') }}
                        <div class="float-right" style="margin-right: 20px;">
                            <v-btn color="warning"
                                @click="user_target_not_ended_show_filters = !user_target_not_ended_show_filters"
                                small
                            >
                                <v-icon>tune</v-icon>
                            </v-btn>
                        </div>
                    </h2>
                </v-col>
            </v-row>
            <v-row v-if="user_target_not_ended_show_filters">
                <v-col cols="6" md="6">
                    <v-text-field
                        v-model="user_target_not_ended_search"
                        prepend-icon="search"
                        clearable
                        :label="trans('common.search')"

                        >
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="user_targets_not_ended.length > 0">
                <v-col cols="12" md="12">
                    <v-data-table
                        :headers="user_target_not_ended_headers"
                        :items="user_targets_not_ended"
                        :items-per-page="10"
                        class="elevation-1"
                        :footer-props="footer"
                        :search="user_target_not_ended_search"
                        :custom-filter="customSearch"
                        >
                        <template v-slot:item.target_deadline="{item}">
                            {{ item.target_deadline | date }}
                        </template>

                        <template v-slot:item.totalEndedActivities="{item}">
                            <v-progress-linear style="border-radius: 8px;"
                                                :value="perc(item.totalActivities, item.totalEndedActivities)"
                                                :color="percCustomColor(item.totalActivities, item.totalEndedActivities)"
                                                height="30">
                                                <small>({{ item.totalEndedActivities }}/{{ item.totalActivities }})
                                                {{ trans('users_targets_progressions.fields.activities') }}</small>
                            </v-progress-linear>
                        </template>

                        <template v-slot:item.target_allocated_time="{item}">
                            {{ roundedHours(item.target_allocated_time) }}
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" md="12">{{ trans('common.no_results') }}</v-col>
            </v-row>

            <v-row>
                <v-col cols="7" md="7">
                    <v-row>
                        <v-col cols="12" md="12">
                            <h2>
                                {{ trans('user_detail.to_verify') }}
                                <div class="float-right" style="margin-right: 20px;">
                                    <v-btn color="warning"
                                    @click="user_target_to_completed_show_filters = !user_target_to_completed_show_filters"
                                    small
                                    >
                                        <v-icon>tune</v-icon>
                                    </v-btn>
                                </div>
                            </h2>
                        </v-col>
                    </v-row>
                    <v-row v-if="user_target_to_completed_show_filters">
                        <v-col cols="6" md="6">
                            <v-text-field
                                v-model="user_target_to_completed_search"
                                prepend-icon="search"
                                clearable
                                :label="trans('common.search')"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="user_targets_to_completed.length > 0">
                        <v-col cols="12" md="12">

                            <v-data-table
                                :headers="user_target_to_completed_headers"
                                :items="user_targets_to_completed"
                                :items-per-page="10"
                                class="elevation-1"
                                :footer-props="footer"
                                :search="user_target_to_completed_search"
                                :custom-filter="customSearch"
                                >

                                <template v-slot:item.target_deadline="{item}">
                                    {{ item.target_deadline | date  }}
                                </template>
                                <template v-slot:item.user_target_ended="{item}">
                                    {{ item.user_target_ended | date  }}
                                </template>
                                <template v-slot:item.target_allocated_time="{item}">
                                    {{ roundedHours(item.target_allocated_time) }}
                                </template>

                                <template v-slot:item.id="{item}">
                                    <v-btn depressed small color="warning" :href="user_target_edit_route(item.id)"><v-icon>edit</v-icon></v-btn>
                                </template>

                            </v-data-table>


                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="12" md="12">{{ trans('common.no_results') }}</v-col>
                    </v-row>
                </v-col>
                <v-col cols="5" md="5">
                    <v-row>
                        <v-col cols="12" md="12">
                            <h2>
                                {{ trans('user_detail.goals_achieved') }}
                            </h2>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-card
                                width="600"
                                outlined
                                max-height="300"
                                class="overflow-y-auto"
                                flat
                                style="border: 0px;"
                                >

                                <template v-if="user_targets_completed.length > 0">
                                    <v-list-item v-for="(goal, gid) in user_targets_completed" :key="gid"
                                        style="background-color: #526C5C; border-radius: 10px; margin-top: 10px; margin-right: 20px;"
                                    >
                                        <v-list-item-avatar
                                            tile
                                            size="30"
                                        >
                                            <v-img  src="/icons/reward-work-icon.png" style="border-radius: 50%;" max-width="80px" />
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title style="color:white;">{{ goal.target_name }}</v-list-item-title>
                                            <v-list-item-subtitle style="color:white;">{{ goal.target_deadline | date }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>

                                </template>
                                <v-card-text v-else>
                                    <v-row>
                                    <v-col cols="12" md="12">{{ trans('common.no_results') }}</v-col>
                                </v-row>
                                </v-card-text>

                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>


export default {

    name: "user-summary",

    props: {
        user: { type: Object, default: {} },
        user_targets_not_ended: { type: Array, default: [] },
        user_targets_to_completed: { type: Array, default: [] },
        user_targets_completed: { type: Array, default: [] },
        user_target_action: { default: ''}

    },
    data() {
        let data = this.user;

        let goals = [
            { name:'10 obiettivi completati', date: '10/11/2023' },
            { name:'1 obiettivo anticipato', date: '17/11/2023' },
        ];
        return {
            data,
            goals,
            user_target_not_ended_headers: [

            { text: trans('users_targets_progressions.fields.target_name'), value: 'target_name' },
            { text: trans('users_targets_progressions.fields.target_deadline'), value: 'target_deadline' },
            { text: trans('users_targets_progressions.fields.user_target_worked_time_sec') , value: 'totalEndedActivities' },
            { text: trans('users_targets_progressions.fields.target_allocated_time'), value: 'target_allocated_time' },

            ],

            user_target_to_completed_headers: [
            { text: trans('users_targets_progressions.fields.target_name'), value: 'target_name' },
            { text: trans('users_targets_progressions.fields.target_deadline'), value: 'target_deadline' },
            { text: trans('users_targets_progressions.fields.user_target_ended') , value: 'user_target_ended' },
            { text: trans('users_targets_progressions.fields.target_allocated_time'), value: 'target_allocated_time' },
            { text: '', sortable: false, value: 'id' },

            ],

            footer: {
                itemsPerPageText: trans('common.table.footer.items_per_page'),
                itemsPerPageAllText: trans('common.table.footer.items_per_page_all'),
            },

            user_target_not_ended_search: '',
            user_target_to_completed_search: '',
            user_target_not_ended_show_filters: false,
            user_target_to_completed_show_filters: false,
        }
    },

    mounted() {
    },
    methods: {


        customSearch (value, search, item) {

            return Object.values(item).some(
            v=>v
            && (v.toString().toLowerCase().includes(search)
            || v.toString().toUpperCase().includes(search))
            )
        },


        user_target_edit_route(item_id){
            let action = this.user_target_action;
            return action.replace(':id',item_id)
        },


        roundedHours(second_hours) {
            let fl_hours = second_hours / 3600;
            return Math.round(fl_hours * 100) / 100
        },

        perc(max, current) {
            let kx = 100.0 / parseFloat(max);
            let y = parseFloat(current) * kx;
            return Math.round(y * 100.0) / 100.0;

        },

        percCustomColor(max, min) {

            let perc = this.perc(max, min);

            // default green
            let color = '#4CAF50'; // 100%
            let background_color = '#A5D6A7';

            if (perc < 25.0) {
                // red
                color = '#F44336';
                background_color = '#EF9A9A';

            } else if (perc <= 50.0) {
                // orange
                color = '#FFB74D'; // orange lighten-2
                background_color = '#FFE0B2'; // orange lighten-4


            } else if (perc < 75.0) {
                // orange
                color = '#FF9800';
                background_color = '#FFE0B2';


            } else if (perc > 105) {

                background_color = '#EF9A9A';

                if (perc < 110) {
                    // lime darken-4
                    color = '#827717';

                } else if (perc < 125) {
                    // deep-orange darken-4
                    color = '#BF360C';

                } else if (perc < 150) {
                    // red accent-4
                    color = '#D50000';

                } else if (perc < 175) {
                    // pink accent-4
                    color = '#C51162';

                } else if (perc > 175) {
                    // purple accent-4
                    color = '#AA00FF';
                }

            }

            return color;
        },


    },

    computed: {


    },



}

</script>
